import { call, put, select, takeLatest } from "redux-saga/effects";
import { triggerConfirmar, yes } from "./confirmationSlice";
import { isNotNull } from "../functions";

function* doConfirmar() {
    yield call(() => console.log("Confirmando"))
    var cb = yield select ((state) => state.confirmation.cb)

    console.log("CB NULL?", isNotNull(cb))
    if(isNotNull(cb)) {
        console.log("Calling CB")
        cb()
    }
    yield put(yes())
}

export function* listenConfirmar() {
    yield takeLatest(triggerConfirmar, doConfirmar)
}